import React from 'react'
import { motion } from 'framer-motion'
import { Shield } from 'lucide-react'

const LoadingScreen = () => {
  return (
    <div className="fixed inset-0 surface-primary flex items-center justify-center">
      <div className="text-center">
        <motion.div
          animate={{ 
            rotate: [0, 2, -2, 0],
            scale: [1, 1.02, 1]
          }}
          transition={{ 
            duration: 4,
            repeat: Infinity,
            ease: "easeInOut"
          }}
          className="mb-8 inline-block p-4 bg-white rounded-2xl shadow-sm border border-gray-200"
        >
          <Shield className="w-16 h-16 text-gray-700 mx-auto" />
        </motion.div>
        
        <motion.h1 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="text-4xl font-bold text-gray-900 mb-4"
        >
          Stash
        </motion.h1>
        
        <motion.p 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="text-gray-600 text-lg"
        >
          Initializing your secure vault<span className="loading-dots">...</span>
        </motion.p>
        
        <motion.div 
          initial={{ width: 0 }}
          animate={{ width: "100%" }}
          transition={{ delay: 0.6, duration: 1.5, ease: "easeInOut" }}
          className="mt-8 h-1 bg-gray-400 rounded-full max-w-xs mx-auto"
        />
      </div>
    </div>
  )
}

export default LoadingScreen
